import { UserRoles } from '../../api/queries.ts';

export class SafetyRepRolesUtils {
  /** Safety representatives without any other role than member start in the safety representative area */
  public static isOnlySafetyRep(userRoles: ReadonlyArray<string>): boolean {
    return (
      userRoles.includes(UserRoles.SAFETY_REP) &&
      userRoles.every((role) => role === UserRoles.SAFETY_REP || role === UserRoles.MEMBER)
    );
  }
}
